
import profile from "assets/images/hfprofile.svg";
import Button from "components/button";
import PhoneField from "components/phone-number-input";
import TextField from "components/textfield";
import { useUser } from "hooks";
import React from "react";

export default function Desktop() {
  const { user } = useUser();

  return (
    <div className="w-[100%] h-[90%] flex items-center justify-center">
      <div className="w-[95%] h-[100%] shadow-[0_30px_50px_-15px_rgba(0,0,0,0.3)] rounded-lg border border-[#DDDDDD] flex items-center justify-center flex-col gap-4 pb-2">
        <div className="w-[90%] h-[20%] pl-[30px] pt-[10px] flex flex-col items-start justify evenly">
          <h1 className="text-[30px] font-medium">Update HF Profile</h1>
          <p className="text-[14px] font medium">
            Enter your new HF profile details
          </p>
          <div className="w-[940px] h-[0.1px] bg-[#DDDDDD]"></div>
        </div>
        <div className="w-[85%] h-[85%]  flex items-center justify-between">
          <div className="w-[30%] h-[80%] mb-[5px] rounded-lg fit-cover">
            <img src={profile} alt="" className="w-[100%] h-[100%]" />
          </div>
          <div className="w-[68%] h-[90%] flex flex-col gap-4">
            <div className="grid grid-cols-3 gap-4 w-full">
              <TextField label="Name of Health Facility" value={""} />
              <TextField label="Company Email" value={""} />
              <TextField label="Location" value={""} />
              <TextField label="Opening hour" value={""} type="time" />
              <TextField label="Closing hour" value={""} type="time" />
              <TextField label="Address of Health Facility" value={""} />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <PhoneField label="Phone number" value={user?.phone} />
              <PhoneField label="Whatsapp number" value={""} />
            </div>
            <Button label="Update HF Profile" fullWidth size="large" />
          </div>
        </div>
      </div>
    </div>
  );
}